var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPytorchIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10167_18533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 10,
    width: 30,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H31V21.6148H1V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10167_18533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 10H29.3432C28.8832 10 28.4536 10.228 28.1952 10.608L25.9792 13.8776C25.9656 13.8976 25.9472 13.9141 25.9258 13.9254C25.9043 13.9367 25.8805 13.9427 25.8562 13.9427C25.8319 13.9427 25.8081 13.9367 25.7866 13.9254C25.7652 13.9141 25.7468 13.8976 25.7332 13.8776L23.5172 10.6084C23.3903 10.4208 23.2193 10.2673 23.0192 10.1612C22.8191 10.0551 22.5961 9.99978 22.3696 10H20.7124L24.6604 15.824L20.7344 21.6148H22.3916C22.8512 21.6148 23.2808 21.3872 23.5388 21.0068L25.7332 17.7696C25.7468 17.7495 25.7652 17.733 25.7867 17.7216C25.8081 17.7102 25.8321 17.7042 25.8564 17.7042C25.8807 17.7042 25.9047 17.7102 25.9261 17.7216C25.9476 17.733 25.966 17.7495 25.9796 17.7696L28.1736 21.0068C28.3006 21.1943 28.4717 21.3479 28.6718 21.4539C28.872 21.5599 29.0951 21.6151 29.3216 21.6148H30.9784L27.0524 15.824L31 10ZM17.3032 11.188V21.6148H18.0952C18.4103 21.6148 18.7125 21.4896 18.9352 21.2668C19.158 21.0441 19.2832 20.7419 19.2832 20.4268V10H18.4912C18.1761 10 17.874 10.1252 17.6512 10.348C17.4284 10.5708 17.3032 10.8729 17.3032 11.188ZM15.8504 10H15.1456C14.7688 9.99968 14.4032 10.1275 14.1087 10.3625C13.8142 10.5976 13.6085 10.9258 13.5252 11.2932L11.9484 18.2244L10.5684 11.7544C10.3132 10.5584 9.086 9.752 7.8304 10.0988C7.0308 10.3196 6.438 10.9952 6.2648 11.8068L4.8988 18.216L3.3252 11.2936C3.24133 10.9263 3.0353 10.5983 2.7408 10.3633C2.4463 10.1283 2.08076 10.0002 1.704 10H1L3.6416 21.6144H4.6424C5.08317 21.6145 5.51063 21.4633 5.85328 21.1861C6.19592 20.9088 6.43298 20.5223 6.5248 20.0912L8.2132 12.1672C8.22371 12.1194 8.25013 12.0766 8.28813 12.0458C8.32614 12.015 8.37348 11.998 8.4224 11.9976C8.5224 11.9976 8.6108 12.0688 8.6316 12.1668L10.322 20.0916C10.4139 20.5226 10.651 20.909 10.9936 21.1862C11.3363 21.4634 11.7637 21.6146 12.2044 21.6144H13.2084L15.8504 10Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorchIcon11);
export default __webpack_public_path__ + "static/media/pytorch-icon-1-1.ab2ce158db0b1d2bdc028187dfed4558.svg";
export { ForwardRef as ReactComponent };